import Index from './Reports'
import IndexHeading from './IndexHeading'

export default {
  Index,
  IndexHeading
}



// WEBPACK FOOTER //
// ./src/components/reports/index.js